import { create } from "zustand";

interface PanoramaPopupState {
  id: number | null;
  setId: (id: number | null) => void;
  imageUrl: string | null;
  setImageUrl: (imageUrl: string | null) => void;
  panoramaUrl: string | null;
  setPanoramaUrl: (panoramaUrl: string | null) => void;
  isOpen: boolean;
  openPopup: () => void;
  closePopup: () => void;
}

const usePanoramaPopupStore = create<PanoramaPopupState>((set) => ({
  id: null,
  setId: (id) => set({ id }),
  imageUrl: null,
  isOpen: false,
  setImageUrl: (imageUrl) => set({ imageUrl }),
  panoramaUrl: null,
  setPanoramaUrl: (panoramaUrl) => set({ panoramaUrl }),
  openPopup: () => set({ isOpen: true }),
  closePopup: () => set({ imageUrl: null, id: null, isOpen: false }),
}));

export default usePanoramaPopupStore;
